import React, { useState, useEffect } from 'react';
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, YoutubeOutlined } from '@ant-design/icons';
import api from '../../services/api';

const SocialLinks = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSocialLinks();
  }, []);

  const fetchSocialLinks = async () => {
    try {
      const response = await api.get('/social_links');
      if (response.data.success) {
        setLinks(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching social links:', error);
    } finally {
      setLoading(false);
    }
  };
const XIcon = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>X (formerly Twitter)</title>
    <path d="M20.39 3H17.7l-5.27 6.75L7.33 3H3.5l6.73 9.06L3 21h2.69l5.64-7.22L16.7 21H20.5l-7.13-9.63L20.39 3z" />
  </svg>
);
  const getIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return <FacebookOutlined />;
      case 'twitter':
        return <XIcon />;
      case 'instagram':
        return <InstagramOutlined />;
      case 'linkedin':
        return <LinkedinOutlined />;
      case 'youtube':
        return <YoutubeOutlined />;
      default:
        return null;
    }
  };

  return (
    <div className="social-links">
      {loading ? (
        <div>Loading...</div>
      ) : (
        links
          .filter(link => link.is_active)
          .map(link => (
            <a 
              key={link.id}
              href={link.url}
              target="_blank"
              style={{marginLeft:'10px', fontSize:'25px', color:'white'}}
              rel="noopener noreferrer"
              className="social-link"
              title={link.platform}
            >
              {getIcon(link.platform)}
            </a>
          ))
      )}
    </div>
  );
};

export default SocialLinks;